module.exports = "/packs/images/svg/ireland/accessibility/accessible_changing~b6e4a3d03f7fe27682f0e6cbdd40e704.svg";